export default "__VITE_ASSET__Ey9qM1wl__"